import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import DashboardMenu from './common/dashboard-menu';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getAllPayment, getProfile } from '../../core/data/redux/action';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../core/data/redux/store';
import Pagination from '../common/pagination';
import Lottie from 'lottie-react';
import Loader from '../../core/data/img/car_loading.json';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';

const UserPayment = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { paymentLoading, paymentList } = useSelector((state: RootState) => ({
    paymentLoading: state.payment.paymentLoading,
    paymentList: state.payment.paymentList,
  }));

  const [userPayment, setUserPayment] = useState([]);
  const [
    searchInput,
    // setSearchInput
  ] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState(searchInput);

  const BookingDetails = (res: any) => {
    return (
      <div className="table-avatar">
        <div className="table-head-name flex-grow-1">
          <p>#{res?.booking?.booking_id}</p>
        </div>
      </div>
    );
  };

  // const UserDetails = (res: any) => {
  //   return (
  //     <div className="table-avatar">
  //       <div className="table-head-name flex-grow-1">
  //         <Link to="#">{res.user?.name}</Link>
  //         <p>{res.user?.email}</p>
  //       </div>
  //     </div>
  //   );
  // };

  const PaidOn = (res: any) => {
    return <p>{res.created_at}</p>;
  };

  const TransactionNo = (res: any) => {
    return <p>{res.transaction_no ?? 'N/A'} </p>;
  };

  const TotalAmount = (res: any) => {
    return <p>${res.amount} </p>;
  };

  const status = (res: any) => {
    return (
      <span
        className={`${
          res.status == 'Refunded'
            ? 'badge badge-light-secondary'
            : res.status == 'Refund Initiated'
              ? 'badge badge-light-secondary'
              : res.status == 'Pending'
                ? 'badge badge-light-warning'
                : res.status == 'Failed'
                  ? 'badge badge-light-danger'
                  : res.status == 'Completed'
                    ? 'badge badge-light-success'
                    : ''
        }`}
      >
        {res.status}
      </span>
    );
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchInput]);

  useEffect(() => {
    dispatch(getAllPayment({ itemsPerPage: 10, page: 1 }));
  }, [debouncedSearch]);

  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(getProfile());
    }
  }, []);

  useEffect(() => {
    setUserPayment(paymentList?.data ?? []);
  }, [paymentList]);

  const [first, setFirst] = useState(0);

  const onPage = (event: any) => {
    setFirst(event);
    dispatch(getAllPayment({ itemsPerPage: 10, page: event }));
  };

  return (
    <>
      <DashboardMenu />
      <div className="content">
        <div className="container">
          <div className="row">
            {paymentLoading ? (
              <div className="  d-flex justify-content-center align-items-center">
                <Lottie
                  animationData={Loader}
                  loop={true}
                  style={{ width: 300, height: 300 }}
                />
              </div>
            ) : paymentList?.meta?.total_items > 0 ? (
              <div className="col-lg-12 d-flex">
                <div className="card book-card flex-fill mb-0">
                  <div className="card-header mt-0 pt-0 px-0">
                    <div className="row align-items-center">
                      <div className="col-md-5">
                        <h4>
                          All Payments{' '}
                          <span>{paymentList?.meta?.total_items ?? 0}</span>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className=" ">
                    <div className="table-responsive dashboard-table">
                      <DataTable
                        className="table datatable"
                        value={userPayment}
                        selectionMode="single"
                      >
                        <Column
                          field="bookingID"
                          header="Booking ID"
                          body={BookingDetails}
                        ></Column>
                        {/* {user?.isAdmin && (
                          <Column
                            field="user"
                            header="User"
                            body={UserDetails}
                          ></Column>
                        )} */}
                        <Column
                          field="transactionNo"
                          header="Transaction No"
                          body={TransactionNo}
                        ></Column>
                        <Column
                          field="paidOn"
                          header="Paid on"
                          body={PaidOn}
                        ></Column>
                        <Column
                          field="total"
                          header="Total"
                          body={TotalAmount}
                        ></Column>
                        <Column
                          field="status"
                          header="Status"
                          body={status}
                        ></Column>
                      </DataTable>

                      {paymentList?.meta?.total_pages > 1 && (
                        <div className="d-flex justify-content-center justify-content-md-end p-2 my-2">
                          {paymentList?.meta?.total_pages > 0 && (
                            <Pagination
                              currentPage={first || 1}
                              totalPages={paymentList?.meta?.total_pages || 1}
                              onPageChange={onPage}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-lg-12 d-flex">
                <div className="card book-card flex-fill mb-0">
                  <div className="card-header mb-1 mt-0 pt-0 px-0">
                    <p>No payments found</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserPayment;
